import { Action, Reducer } from 'redux';
import { PassPdf } from './passPdf';
import { ACTION_TYPE } from '../../../../core/redux/actionType';
import { IAppState } from '../../../../core/redux/IAppState';
import { assoc } from '../../../../language/module';


export const markGuestPdfPrintedAction = (pdf: PassPdf) => ({
  type:    ACTION_TYPE.MARK_GUEST_PDF_PRINTED,
  passPdf: pdf,
});


export const markGuestPdfPrintedReducer: Reducer<IAppState> = (state: IAppState, action: Action): IAppState => {
  if (action.type !== ACTION_TYPE.MARK_GUEST_PDF_PRINTED) {
    return state;
  }

  const passPdf = (action as any).passPdf;

  return assoc(
    'passPrinting',
    {
      pdfs:    state.passPrinting.pdfs.filter(pdf => pdf !== passPdf),
      printed: state.passPrinting.printed.concat(passPdf.guestIds),
    },
    state,
  );
};
